window.onscroll = function () {
  scrollingProgressBar();
};
function scrollingProgressBar() {
  var htuSection = document.querySelector('.how-to-use .items-with-name').getBoundingClientRect();

  if (htuSection.top <= document.documentElement.clientHeight) {
    var scrollHeight = document.documentElement.clientHeight / 2 - htuSection.top;
    var winScroll = (scrollHeight / htuSection.height) * 100;
    var styleHeight = Math.ceil(winScroll) > 100 ? 100 : Math.ceil(winScroll);

    document.querySelector('.htu-item-line.progress').style.height = `${
      styleHeight == 100 ? 'calc(100% - 30px)' : styleHeight + '%'
    }`;

    var allNumber = document.querySelectorAll('.htu-item-num');
    var numReachedAt = Math.ceil((winScroll / 100) * allNumber.length);

    var currentNumber = document.querySelector(`[data-htu-index='${numReachedAt}']`)?.getBoundingClientRect();

    if (currentNumber?.top <= document.documentElement.clientHeight / 2) {
      document.querySelector(`[data-htu-index='${numReachedAt}']`)?.classList.add('sc-active');
    } else if (currentNumber?.top >= document.documentElement.clientHeight / 2) {
      document.querySelector(`[data-htu-index='${numReachedAt}']`)?.classList.remove('sc-active');
    }
  }
}
